const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "http://localhost:5001/",
        domainAdminSite: "http://localhost:3000",
        domainUserSide: "http://localhost:3000",
        domainName: "",
  },
  production: {
      api: "https://quyhoachquocgia-api.cgis.asia/",
      domainAdminSite: "https://admin.quyhoachquocgia.cgis.asia",
      domainUserSide: "https://admin.quyhoachquocgia.cgis.asia",
      domainName: "quyhoachquocgia.cgis.asia",
  },
};

module.exports = apiEnvironment[env];
